import React from 'react'
import "./OurBlog.css";
import background1 from '../images/png/FliqaIndiawedding.png';
import background2 from '../images/png/WeddingTrailer.png';
import now1 from '../images/png/FliqaIndiawedding (2).png'
import now2 from '../images/png/FliqaIndiawedding (1).png'
import now3 from '../images/png/WeddingTrailer (1).png'





const OurBlog=()=> {
  return (
    <div>
        <div className='ourblog'>
            <div className='Blog'>
                <h1>Our Blog</h1>
                <p>Check out our Latest Blog</p>
            </div>
            <div className='blogCard'>
                <div className='Goa'style={{ backgroundImage: `url(${background1})`,backgroundRepeat:"no-repeat" }} >
                    <div className='goafeature'>
                        <h4>Featured on:Sep 15,2021</h4>
                        <h2>Wedding<br/>Photography<br/>at Goa</h2>
                        
                    </div>  
                </div>
                <div className='Goa' style={{ backgroundImage: `url(${background2})`,backgroundRepeat:"no-repeat" }}>
                    <div className='goafeature' >
                        <h4>Featured on:Sep 15,2021</h4>
                        <h2>Photography<br/>Expectations<br/>vs. Reality</h2>
                    </div>  
                </div>
                <div className='trend'>
                    <div className='now'>
                        <h3>Trending Now</h3>
                        <h4>View All</h4>
                    </div>
                    <div className='nowbottum'>
                        <img src={now1} alt="err"/>
                        <h3>Creative Industries are on the ver of<br/> depletion due to COVID-19 <br/> In a period where many industries remain<br/> unclear, others want to are impact</h3>  
                    </div>
                    <div className='nowbottum'>
                        <img src={now2} alt="err"/>
                        <h3>Photography: Expectations vs. Reality<br/> Most of the time without any hands-on<br/>in photography, professional and advanced <br/> photography actually</h3>  
                    </div>
                    <div className='nowbottum'>
                        <img src={now3} alt="err "/>
                        <h3>Wedding Photography at Goa<br/> Wedding Photography in Goa If not, every<br/> when they make their list of Pre-wedding shoot</h3>  
                    </div>

                    
                </div>
                
            </div>
            
        </div>


    </div>
  )
}
export {OurBlog}
